import { Avatar } from 'antd';
import { Ban, UserRound } from 'lucide-react';
import { getFullName, getInitials } from '../../utils';


const UserAvatar = ({ user, style, size, isDanger = false, }) => {
  const fullName = getFullName(user);

  const isSizeNumber = typeof size === 'number';

  return (
    <Avatar style={{
      fontSize: isSizeNumber ? size / 2 : 'inherit',
      ...style,
      background: (isDanger) && '#D2665A'
    }} size={size}>
      {isDanger ? <Ban size={size / 2} /> : getInitials(fullName) || <UserRound size={size / 2} />}
    </Avatar>
  );
};

export default UserAvatar;
